export interface LineChartDataset {
  label: string;
  data: number[];
  color?: string;
}

export interface LineChartData {
  title: string;
  xLabel?: string;
  yLabel?: string;
  labels: string[];
  datasets: LineChartDataset[];
}

const DEFAULT_COLORS = ["#f59e0b", "#3b82f6", "#10b981", "#8b5cf6", "#ef4444"];

export function parseLineChartBlock(jsonStr: string): LineChartData | null {
  try {
    const raw = JSON.parse(jsonStr);

    if (
      typeof raw.title !== "string" ||
      !Array.isArray(raw.labels) ||
      raw.labels.length === 0 ||
      !Array.isArray(raw.datasets) ||
      raw.datasets.length === 0
    )
      return null;

    for (const label of raw.labels) {
      if (typeof label !== "string") return null;
    }

    const datasets: LineChartDataset[] = [];
    for (let i = 0; i < raw.datasets.length; i++) {
      const ds = raw.datasets[i];
      if (
        typeof ds.label !== "string" ||
        !Array.isArray(ds.data) ||
        ds.data.length !== raw.labels.length
      )
        return null;

      for (const val of ds.data) {
        if (typeof val !== "number") return null;
      }

      datasets.push({
        label: ds.label,
        data: ds.data,
        color: typeof ds.color === "string" ? ds.color : DEFAULT_COLORS[i % DEFAULT_COLORS.length],
      });
    }

    return {
      title: raw.title,
      xLabel: typeof raw.xLabel === "string" ? raw.xLabel : undefined,
      yLabel: typeof raw.yLabel === "string" ? raw.yLabel : undefined,
      labels: raw.labels,
      datasets,
    };
  } catch {
    return null;
  }
}
